<template>
    <i :class="resolvedClass"
       :style="resolvedStyles"
       aria-hidden="true"
    />
</template>

<script setup>
// TODO: This needs to be converted to a DevDash component. To fully integrate with the system design.
import { computed } from "vue";
import { iconRegistry } from "@common/icon/iconRegistry";

const props = defineProps({
    name: String,
    size: String,
    color: String
});

const sizeClassMap = {
    xs: "--text-xs",
    sm: "--text-sm",
    base: "--text-base",
    lg: "--text-lg",
    xl: "--text-xl",
    '2xl': "--text-2xl",
    '3xl': "--text-3xl",
    '4xl': "--text-4xl",
};

const resolvedStyles = computed(() => {
    const sizeVar = sizeClassMap[props.size] ?? sizeClassMap.base;

    return {
        fontSize: `var(${sizeVar})`,
        color: props.color || 'var(--color-text)'
    };
});

const resolvedClass = computed(() => iconRegistry[props.name] || props.name);

// TODO: future--deliver messages to developer in dev mode.
// if (process.env.NODE_ENV === 'development') {
//     if (props.name && props.fa) {
//         console.warn(
//             `[Icon] Both 'name' and 'fa' were provided. 'name' takes priority.`
//         )
//     }
//
//     if (!props.name && !props.fa) {
//         console.warn(`[Icon] No icon provided.`)
//     }
// }

</script>
